import { getThreadHealth, updateThreadOptions } from '@/services/api/agent'
import { DEFAULT_AGENT_OPTIONS } from './AgentOptionsContext'

const RESOLUTION_TOOLS = new Set([
  'summarize_entity_resolution',
  'plan_entity_resolution_merge',
  'merge_entity_resolution',
  'get_entity_resolution_merge_status',
])

/** A resolution launch belongs to standard chat, even after viewing a research run. */
export function promptNeedsStandardChat(
  requestedCaseId: string | undefined,
  caseId: string | undefined,
  activeKind: string | undefined
): boolean {
  return Boolean(
    requestedCaseId && requestedCaseId === caseId && activeKind && activeKind !== 'chat'
  )
}

/** Save required chat settings before offering the resolution draft for sending. */
export async function prepareResolutionConversation(caseId: string, threadId: string) {
  const health = await getThreadHealth(caseId, threadId)
  const current = health.agent_options ?? DEFAULT_AGENT_OPTIONS
  if (!current.deep_mode && !current.disabled_tools.some(name => RESOLUTION_TOOLS.has(name)))
    return health
  const options = {
    deep_mode: false,
    disabled_tools: current.disabled_tools.filter(name => !RESOLUTION_TOOLS.has(name)),
  }
  await updateThreadOptions(caseId, threadId, options)
  return { ...health, agent_options: options }
}
